class ArrayDecorator<T> {
  static DEFAULT_INDEX = -1;

  private array: Array<T>;

  constructor(arr: Array<T>) {
    this.array = arr || [];
  }

  isEmpty(): boolean {
    return !this.array || this.array.length === 0;
  }

  size(): number {
    return this.array.length;
  }

  sort(): void {
    this.array.sort();
  }

  get(index: number): T {
    return this.array[index];
  }

  findFirst(predicate: (elt: T) => boolean): T {
    if (this.array.length > 0) {
      for (const item of this.array) {
        if (predicate(item)) return item;
      }
    }

    return null;
  }

  findFirstIndex(predicate: (elt: T) => boolean): number {
    if (this.array.length > 0) {
      let idx = 0;
      for (const item of this.array) {
        if (predicate(item)) return idx;
        idx++;
      }
    }

    return ArrayDecorator.DEFAULT_INDEX;
  }

  contains(predicate: (elt: T) => boolean): boolean {
    return this.findFirstIndex(predicate) > ArrayDecorator.DEFAULT_INDEX;
  }

  containsElement(elt: T): boolean {
    return this.contains((item: T) => item === elt);
  }

  remove(predicate: (elt: T) => boolean): boolean {
    let removed = false;

    if (predicate) {
      let index: number;
      while ((index = this.findFirstIndex(predicate)) > ArrayDecorator.DEFAULT_INDEX) {
        this.array.splice(index, 1);
        removed = true;
      }
    }

    return removed;
  }

  containsExactlySameElementsInAnyOrder(arr2: Array<T>): boolean {
    const array2 = arr(arr2);

    if (this.size() !== array2.size()) {
      return false;
    }
    this.array.forEach((e1) => {
      if (!array2.containsElement(e1)) {
        return false;
      }
    });

    return true;
  }

  /**
   * Mover elt to newIndex. Be careful, newIndex should correspond index where elt should be at that time calling the method
   * @param elt
   * @param newIndex
   */
  move(elt: T, newIndex: number): Array<T> {
    const oldIndex = this.array.indexOf(elt);

    if (oldIndex < 0) {
      throw "Elt not present in array";
    }

    if (oldIndex < newIndex) newIndex--;

    if (newIndex < 0) {
      throw "error new index" + newIndex + " < 0";
    }

    this.array.splice(oldIndex, 1);
    this.array.splice(newIndex, 0, elt);

    return this.array;
  }

  push(item: T) {
    return this.array.push(item);
  }
}

const arr = <T>(arr: Array<T>) => new ArrayDecorator(arr);
export default arr;
